export default __webpack_public_path__ + "static/footer-graphic-mobile-a7414d18c8b1bb1f798a4247dd4389f6.png";